<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";
import { INews } from "~/types/config/news";
import api from "~/utils/auth/api";
import NewsItem from "./NewsItem.vue";
import { DateTime as Luxon } from "luxon";

const cookie = useCookie("newsbox", {
	expires: Luxon.now().plus({ days: 7 }).toJSDate(),
});

const { data } = useQuery<{ newsBoxItems: INews[] }>({
	queryKey: ["newsbox"],
	queryFn: () =>
		api({
			url: "/cron/newsboxitems/{brand}",
			type: "config",
			options: { method: "GET" },
		}),
});

const hiddenNews = computed(() => {
	let copy: string = cookie.value ? `${cookie.value}` : "";

	return copy || "";
});

const handleClose = (id: string) => {
	let newVal = [];
	let copy: string = cookie.value ? `${cookie.value}` : "";
	const currentVal = isJsonString(copy) ? JSON.parse(copy) : null;
	if (currentVal) {
		newVal = [...currentVal, id];
	} else {
		newVal = [id];
	}
	cookie.value = JSON.stringify(newVal);
};

const usableNewsBox = computed(() => {
	if (!data.value) return [];
	return data.value.newsBoxItems.filter((x) => hiddenNews.value.indexOf(x.id) === -1);
});
</script>

<template>
	<div
		v-if="data?.newsBoxItems.length && usableNewsBox.length > 0"
		class="flex flex-col w-[calc(100%+16px)] -mx-2 md:mx-0 md:w-full gap-2 -mt-2 md:mt-0 mb-4 md:mb-2"
	>
		<NewsItem v-for="news in usableNewsBox" :key="news.id" :news="news" @handle-close="(id) => handleClose(id)" />
	</div>
</template>
